<template>
  <section>
    <div class="row LP-header">
      <div class="col">
        <div class="container">
          <router-link
            :to="{ name: 'main-application', params: $route.params.id }"
            aria-label="Back to loan overview"
            tabindex="4"
          >
            <h1 style="font-weight: normal;cursor: pointer" class="display-4">
              <round-icon name="ni ni-archive-2" type="primary" ></round-icon>
             
              <!-- TODO: Tie to Loan TypeID -->
              Mortgage Loan
              <small class="text-muted"
                >/ Documents
                <i class="fa fa-lock text-success success" aria-hidden="true"></i
              ></small>
            </h1>
          </router-link>

          <div
            class="col"
            style="margin-top: -2rem;margin-left: 2.5rem;padding-right: 2.5rem;"
          >
            <base-progress
              v-if="app.progress"
              style="padding: 0; margin-top: 20px;margin-bottom: -30px;"
              type="primary"
              :value="app.progress.sections.documents.progress"
              :showPercent="false"
            ></base-progress>
          </div>
        </div>
      </div>
    </div>
    <div class="container" style="padding-top: 40px;overflow-y: scroll;padding-bottom: 160px;">
      <div class="row" style="margin-top: 40px">
        <div class="col-sm">
          <div class="loader" v-if="loading" style="margin-top: -3rem;">
            <div class="loader-box">
              <i
                class="fa fa-spinner success"
                :style="{ color: $theme.success }"
                aria-hidden="true"
              ></i>
            </div>
          </div>
          <template>
            <h4>Required Documents</h4>
            <div class="sections">
              <div class="section" v-if="section.ID" style="padding: .5rem 0 0">
                <h5>{{ section.Title }}</h5>
                <p v-html="section.Description"></p>
                <div
                  class="docs shadow"
                  v-for="doc of section.data"
                  :key="doc.ID"
                >
                  <h6>{{ doc.Title }}</h6>
                  <p v-html="doc.Description"></p>
                  <div v-if="doc.uploaded && doc.uploaded.data">
                    <div
                      class="uploaded"
                      v-for="up of doc.uploaded.data"
                      :key="up.name"
                    >
                      <div class="info">
                        <i
                          @click="
                            deleteFile = up;
                            deleteConfirm = true;
                          "
                          class="fa fa-times"
                          aria-hidden="true"
                          v-b-popover.hover.top="'Delete Document'"
                        ></i>
                        <div
                          class="name text-primary"
                          v-b-popover.hover.top="'Path: ' + up.path"
                        >
                          {{ up.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="upload">
                    <base-button
                      size="sm"
                      type="primary"
                      @click="openUpload(doc)"
                      ><i class="fa fa-upload" aria-hidden="true"></i>
                      Upload</base-button
                    >
                    <i
                      v-if="doc.loading"
                      style="font-size: 18px"
                      class="fa fa-spinner success"
                      :style="{ color: $theme.success }"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding-bottom: 4rem">
              <base-button
                type="primary"
                style="margin-top: 20px;"
                @click="nextPage"
                >Next</base-button
              >
            </div>
            <input
              id="fileUpload-ipt"
              type="file"
              name=""
              style="display: none"
              accept=".xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.csv"
            />
          </template>
        </div>
      </div>
    </div>
    <modal :show.sync="deleteConfirm" modal-classes="modal-dialog-centered">
      <h6
        slot="header"
        class="modal-title"
        style="color: #f5365c;"
        id="modal-title-notification"
      >
        Delete Document
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-trash text-danger" style="font-size: 42px"></i>
        <h4 class="heading mt-4">Are you sure?</h4>
        <p v-if="deleteFile.name">
          This will delete {{ deleteFile.name }}. Your loan officer will no
          longer be able the access this.
        </p>
      </div>

      <template slot="footer">
        <base-button type="danger" @click="deleteDocument">Delete</base-button>
        <base-button type="link" class="ml-auto" @click="deleteConfirm = false">
          Close
        </base-button>
      </template>
    </modal>
  </section>
</template>
<script>
import {
  getAllDocSections,
  uploadDocument,
  newDocumentFolder,
  removeFile,
  getAllDocuments,
} from "../services/documents";
import { getApplication, saveApplication } from "../services/application";
import { success, warning } from "../services/message";
import BaseButton from "../components/BaseButton.vue";
export default {
  components: { BaseButton },
  name: "documents",

  data() {
    return {
      app: {},
      sections: [],
      loading: false,
      section: {},
      index: 0,
      deleteConfirm: false,
      deleteFile: {},
    };
  },
  async created() {
    // If "new" it is a new application, if ID then get the application.
    if (this.$route.params.id !== "new") {
      this.id = this.$route.params.id;
      let res = await getApplication(this.id);
      this.cobType = res.coBorrower;
      if (res.status === 200 && res.LoanAppJSON) {
        this.app = res.LoanAppJSON;
        this.getSections();
      } else if (res.status === 200) {
        this.getSections();
      } else {
        this.$router.push("/");
        // TODO: popup alert
      }
    } else {
      // TODO: check for current loan app before starting a new one.
      this.getSections();
    }
  },
  methods: {
    async getSections() {
      this.loading = true;
      this.sections = await getAllDocSections();
      if (!this.app.documents) {
        this.app.documents = {};
      }
      this.section = this.sections.data[this.index];
      for (let i = 0; i < this.section.data.length; i++) {
        const s = this.section.data[i];
        s.uploaded = await getAllDocuments(s.Path, this.$route.params.id);
      }
      this.loading = false;
    },
    async nextPage() {
      this.loading = true;
      this.index++;
      let progress = Math.round((this.index / this.sections.data.length) * 100);
      this.app.progress.sections.documents.progress =
        progress > this.app.progress.sections.documents.progress
          ? progress
          : this.app.progress.sections.documents.progress;
      if (this.index !== this.sections.data.length - 1) {
        await this.save();
        this.section = this.sections.data[this.index];
        for (let i = 0; i < this.section.data.length; i++) {
          const s = this.section.data[i];
          s.uploaded = await getAllDocuments(s.Path, this.$route.params.id);
        }
      } else {
        this.app.progress.sections.documents.progress = 100;
        await this.save();
        setTimeout(() => {
          this.$router.push(`/application/${this.$route.params.id}`);
        }, 500);
      }
      this.loading = false;
    },
    async deleteDocument() {
      this.loading = true;
      try {
        await removeFile(this.deleteFile.path, this.$route.params.id);
        this.loading = false;

        success("Document removed");
        for (let i = 0; i < this.section.data.length; i++) {
          const s = this.section.data[i];
          s.uploaded = await getAllDocuments(s.Path, this.$route.params.id);
        }
      } catch (error) {
        warning(error.message);
      }
      this.deleteFile = {};
      this.deleteConfirm = false;
    },
    openUpload(doc) {
      let input = document.getElementById("fileUpload-ipt");
      input.addEventListener("change", async (event) => {
        this.uploadFile(event, doc);
      });
      input.click();
    },
    async uploadFile(event, doc) {
      doc.loading = true;
      try {
        this.loading = true;
        let path = doc.Path.split("/");
        path.pop();
        path.shift();
        let newP = "";
        for (let i = 0; i < path.length; i++) {
          const p = path[i];
          newP += p + "/";
          await newDocumentFolder(newP, this.$route.params.id);
        }
        newP = newP.substring(0, newP.length - 1);
        if (event.target.files[0].type !== "") {
          await uploadDocument(event, this.$route.params.id, newP);
          success("Document Upload Successful");
          for (let i = 0; i < this.section.data.length; i++) {
            const s = this.section.data[i];
            s.uploaded = await getAllDocuments(s.Path, this.$route.params.id);
          }
          this.save();
        } else {
          warning("Document must have a file extension.");
        }
        let input = document.getElementById("fileUpload-ipt");
        let newInput = document.createElement("input");
        newInput.type = "file";
        newInput.id = "fileUpload-ipt";
        newInput.style = "display: none";
        input.replaceWith(newInput);

        this.loading = false;
        doc.loading = false;
      } catch (error) {
        warning("Error Uploading Document");
        this.loading = false;
        doc.loading = false;
      }
    },

    async save() {
      if (this.$route.params.id && this.$route.params.id !== "new") {
       let save = await saveApplication(this.$route.params.id, this.app);
        this.app = save.app
      }
      success("Agreements Saved");
    },
  },
};
</script>
<style lang="scss">
.docs {
  background-color: white;
  padding: 1rem;
  margin-bottom: 2rem;
  border-radius: 4px;
  .uploaded {
    padding: 0 1rem;
    margin-bottom: 0.5rem;
    .info {
      display: flex;
      align-items: center;
      background-color: #f6f9fc;
      margin: 0 -1rem;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      i {
        padding-right: 8px;
        cursor: pointer;
      }
    }
  }
  .upload {
    margin-top: 1rem;
  }
}
</style>
